export const unwrapReportRows = (body: any): any[] => {
  if (Array.isArray(body)) return body;
  const payload = body?.data ?? body;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.calls)) return payload.calls;
  if (Array.isArray(payload?.messages)) return payload.messages;
  return [];
};

const isReportEnvelope = (value: any) =>
  Boolean(
    value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      (Array.isArray(value.data) ||
        Array.isArray(value.calls) ||
        value.pagination ||
        value.stats)
  );

type CallReportActionKey = { key: string; description?: string };

export const parseCallReportPayload = (payload: any) => {
  const root = isReportEnvelope(payload)
    ? payload
    : isReportEnvelope(payload?.data)
    ? payload.data
    : payload;
  const rows = unwrapReportRows(root);
  const nextPagination = Array.isArray(root)
    ? { totalItems: rows.length, totalPages: 1 }
    : root?.pagination || { totalItems: rows.length, totalPages: rows.length ? 1 : 0 };
  const stats =
    !Array.isArray(root) && root?.stats && typeof root.stats === "object"
      ? root.stats
      : null;
  const actionKeys: unknown[] = Array.isArray(root)
    ? []
    : Array.isArray(root?.action_keys)
    ? root.action_keys
    : [];
  return {
    rows,
    pagination: {
      totalItems: Number(nextPagination.totalItems) || 0,
      totalPages: Number(nextPagination.totalPages) || 0,
    },
    stats,
    actionKeys: actionKeys
      .map((item): CallReportActionKey | null => {
        if (typeof item === "string") return { key: item };
        if (item && typeof item === "object" && "key" in item) {
          const key = String((item as { key?: unknown }).key || "");
          if (!key) return null;
          const description = (item as { description?: unknown }).description;
          return {
            key,
            ...(typeof description === "string" ? { description } : {}),
          };
        }
        return null;
      })
      .filter((item): item is CallReportActionKey => Boolean(item?.key)),
  };
};
